// "Ir até a mensagem": quem pede (busca do painel do contato, clique na citação) só dispara
// o evento; a lista de mensagens rola até ela e, se ainda não estiver carregada, busca as
// páginas antigas até encontrar.

const EVENT = "digiteai:jump-to-message";

export const requestJumpToMessage = ({ id, createdAt }) => {
  if (id === undefined || id === null) return;
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { id, createdAt: createdAt || null } }));
};

export const onJumpToMessage = (handler) => {
  const listener = (event) => handler(event.detail || {});
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
};

// Pisca o fundo da bolha por ~1,5 s para o olho achar a mensagem.
export const flashMessage = (element) => {
  if (!element || !element.animate) return;
  const dark = "brightness(0.78)";
  element.animate(
    [
      { filter: "none", offset: 0 },
      { filter: dark, offset: 0.15 },
      { filter: dark, offset: 0.4 },
      { filter: "none", offset: 0.55 },
      { filter: dark, offset: 0.7 },
      { filter: "none", offset: 1 },
    ],
    { duration: 1500, easing: "ease-in-out" }
  );
};

export const scrollToMessage = (id, { smooth = true } = {}) => {
  const target = document.getElementById(`msg-${id}`);
  if (!target) return false;
  target.scrollIntoView({ block: "center", behavior: smooth ? "smooth" : "auto" });
  flashMessage(target);
  return true;
};
